import {ActionService, ApiCallService} from "@libs/ClientService"
import {IGroup} from "@backend/types"

export const groupActions = new ActionService<IGroup>("group")

export const groupApiCalls = new ApiCallService<IGroup>("group")